import { NotFoundPageController } from '@application/components';
import { PRO_PAGE_ROUTE_PER_PRO_TYPE } from '@application/constants';
import { useRouter } from '@application/utils';
import { LoadingOverlay } from '@presentation/components';
import type { LocationDescriptor } from 'history';
import { useMemo } from 'react';
import { Navigate } from 'react-router';
import { useGetPro } from './api/useGetPro';

export const OldProRedirectionController = () => {
  const { infoFromCurrentPath, routeLocationDescriptor } = useRouter();

  const url = useMemo(() => {
    return infoFromCurrentPath.params[1];
  }, [infoFromCurrentPath.params]);

  const { pro, proLoading } = useGetPro(url);

  const location = useMemo((): LocationDescriptor | undefined => {
    if (!pro) return;
    const proUrl = pro.translations?.[0]?.url ?? undefined;
    if (!proUrl) {
      throw new Error('No url found for pro');
    }
    return routeLocationDescriptor(PRO_PAGE_ROUTE_PER_PRO_TYPE[pro.type], { params: [proUrl] });
  }, [pro, routeLocationDescriptor]);

  if (proLoading) return <LoadingOverlay isLoading />;

  if (location) {
    return <Navigate replace to={location} />;
  }

  return <NotFoundPageController />;
};
